module.exports = __webpack_public_path__ + "static/media/fruits_26.ad9c98a2.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_26.csv
// module id = 691
// module chunks = 0